export default function getSelected(state) {
  return state.filter;
}
